/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadAllOfAssignmentsInner
 */
export interface PalSubmissionListEntryLeadAllOfAssignmentsInner {
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadAllOfAssignmentsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadAllOfAssignmentsInner
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof PalSubmissionListEntryLeadAllOfAssignmentsInner
     */
    role: PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum;
}


/**
 * @export
 */
export const PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON'
} as const;
export type PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum = typeof PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum[keyof typeof PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the PalSubmissionListEntryLeadAllOfAssignmentsInner interface.
 */
export function instanceOfPalSubmissionListEntryLeadAllOfAssignmentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSON(json: any): PalSubmissionListEntryLeadAllOfAssignmentsInner {
    return PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadAllOfAssignmentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSON(value?: PalSubmissionListEntryLeadAllOfAssignmentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'role': value.role,
    };
}

